export default [
  {
    path: '/kiwoom/auto-trade/strategy-compare',
    name: 'kiwoom-auto-trade-strategy-compare',
    component: () => import('@/views/kiwoom/StrategyCompare.vue'),
    meta: {
      pageTitle: '자동매매',
      breadcrumb: [
        {
          text: '자동매매',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/rank-info/trade-amount-top',
    name: 'kiwoom-trade-amount-top',
    component: () => import('@/views/kiwoom/TradeAmountRank.vue'),
    meta: {
      pageTitle: '거래대금상위요청',
      breadcrumb: [
        {
          text: '순위정보',
        },
        {
          text: '거래대금상위요청',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/theme-daily',
    name: 'kiwoom-theme-daily',
    component: () => import('@/views/kiwoom/ThemeDaily.vue'),
    meta: {
      pageTitle: '일자별 테마',
      breadcrumb: [
        {
          text: '일자별 테마',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/theme-analysis',
    name: 'kiwoom-theme-analysis',
    component: () => import('@/views/kiwoom/ThemeAnalysis.vue'),
    meta: {
      pageTitle: '일자별 테마 분석',
      breadcrumb: [
        {
          text: '일자별 테마 분석',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/account',
    name: 'kiwoom-account',
    component: () => import('@/views/kiwoom/Account.vue'),
    meta: {
      pageTitle: '계좌',
      breadcrumb: [
        {
          text: '계좌',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/base/condition-search',
    name: 'kiwoom-condition-search',
    component: () => import('@/views/kiwoom/base-register/ConditionSearch.vue'),
    meta: {
      pageTitle: '조건검색',
      breadcrumb: [
        {
          text: '기초등록',
        },
        {
          text: '조건검색',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/base/theme',
    name: 'kiwoom-theme',
    component: () => import('@/views/kiwoom/base-register/Theme.vue'),
    meta: {
      pageTitle: '테마',
      breadcrumb: [
        {
          text: '기초등록',
        },
        {
          text: '테마',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/base/naver-theme',
    name: 'kiwoom-naver-theme',
    component: () => import('@/views/kiwoom/base-register/NaverTheme.vue'),
    meta: {
      pageTitle: '네이버테마',
      breadcrumb: [
        {
          text: '기초등록',
        },
        {
          text: '네이버테마',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/base/stock-item',
    name: 'kiwoom-stock-item',
    component: () => import('@/views/kiwoom/base-register/StockItem.vue'),
    meta: {
      pageTitle: '종목',
      breadcrumb: [
        {
          text: '기초등록',
        },
        {
          text: '종목',
          active: true,
        },
      ],
    },
  },
  {
    path: '/kiwoom/base/securities-company',
    name: 'kiwoom-securities-company',
    component: () => import('@/views/kiwoom/base-register/SecuritiesCompany.vue'),
    meta: {
      pageTitle: '증권회사',
      breadcrumb: [
        {
          text: '기초등록',
        },
        {
          text: '증권회사',
          active: true,
        },
      ],
    },
  },
]
